import React from 'react';
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useParams} from "react-router-dom";
import RenderLoading from "@/components/render-if-loading";
import {Card, Tabs} from "antd";
import {useApiGetAdminTopics} from "@/api/topic";
import {DollarOutlined, FileTextOutlined} from '@ant-design/icons';
import TopicDetailSection from "@/pages/admin/topic/[id]/_section/TopicDetailSection";
import TopicContentSection from "@/pages/admin/topic/[id]/_section/TopicContentSection";
import TopicInstallmentSection from "@/pages/admin/topic/[id]/_section/TopicInstallmentSection";

const {TabPane} = Tabs;

function AdminEditTopicPage(props) {

    const {id} = useParams();

    const {data: topicData, isPending, refetch} = useApiGetAdminTopics({id: id})

    return (
        <AdminLayout pageTitle={'جزئیات سرفصل'} backTo={URLS.admin.topic.dashboard}>
            <RenderLoading loading={isPending} skeleton={true}>

                <TopicDetailSection topicData={topicData}/>

                <Card className="shadow-md">
                    <Tabs defaultActiveKey="contents" type="card">
                        <TabPane
                            tab={<span><FileTextOutlined/> محتواها</span>}
                            key="contents"
                        >
                            <TopicContentSection topicData={topicData} refetch={refetch}/>
                        </TabPane>

                        <TabPane
                            tab={<span><DollarOutlined/> اقساط</span>}
                            key="installments"
                        >
                            <TopicInstallmentSection topicData={topicData}/>
                        </TabPane>

                    </Tabs>
                </Card>


            </RenderLoading>
        </AdminLayout>
    );


}

export default AdminEditTopicPage;